import { Modal, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import BookingCost from './booking-cost';
import DepositDetails from './deposit-details';
import RenewalDetails from './renewal-details';
import DeductionDetails from './deduction-details';
import RefundDetails from './refund-details';
import { useOrderList } from 'hooks/order-management/order-list';
import SPButton from '../../../carRental/base/SPButton';
import DiscountDetails from './discount-details';

interface PropsType {
	enums?: any;
	data?: any;
	permission?: any;
}

// 更改价格显示
const changePriceFormat = (price: any) => {
	if (!price) return price;
	if (!isNaN(Number(price))) {
		price = price / 100;
	}
	return price;
};

const CostInfo: React.FC<PropsType> = props => {
	const { data, enums, permission } = props;
	const { deductionModalOpen, refundModalOpen, unfreezingDepositModalOpen } = useOrderList();

	const [deductBtn, setDeductBtn] = useState(false);
	const [deductStr, setDeductStr] = useState('');
	const [refundBtn, setRefundBtn] = useState(false);
	const [refundStr, setRefundStr] = useState('');
	const [depositBtn, setDepositBtn] = useState(false);
	const [depositStr, setDepositStr] = useState('');

	const refund = () => {
		refundModalOpen(data);
	};

	const unfreezingDeposit = () => {
		unfreezingDepositModalOpen(data);
	};

	const deduction = () => {
		let hasOrder = false;
		const arr = data?.bill?.deposit?.deduct?.deduct_items || [];
		if (arr && arr.length) {
			arr.forEach((item: any) => {
				if (item.deduct_status === 2 || item.deduct_status === 4) {
					// 扣款中或者扣款失败
					hasOrder = true;
				}
			});
		}
		if (!hasOrder) {
			deductionModalOpen(data);
			return;
		}
		Modal.confirm({
			centered: true,
			width: 550,
			title: '当前扣款明细内存在扣款中或扣款失败状态不可重复操作扣款',
			okText: '确认',
        	cancelText: '取消',
			content: (
				<>
					<div>扣款中：需要等待扣款成功后在操作</div>
					<div>扣款失败：需要您手动撤回失败扣款后在操作</div>
				</>
			),
		});
	};

	useEffect(() => {
		const auth = data?.bill?.deposit?.authorize_status;
		if (auth === 0) {
			// 未授权
			setDeductBtn(true);
			setDeductStr('未授权押金，不可操作');
			return;
		}
		const status = data?.bill?.deposit?.deposit_status;
		if (status === 3) {
			// 押金全部解冻
			setDeductBtn(true);
			setDeductStr('押金已全部解冻，不可操作');
			return;
		}
		setDeductBtn(false);
		setDeductStr('');
	}, [data?.bill?.deposit?.authorize_status, data?.bill?.deposit?.deposit_status]);

	useEffect(() => {
		const amount = data?.order_info?.bill_info?.settle_amount;
		if (!amount) {
			// 可退款金额为0
			setRefundBtn(true);
			setRefundStr('订单金额已全额退款，不可操作');
			return;
		}
		setRefundBtn(false);
		setRefundStr('');
	}, [data?.order_info?.bill_info?.settle_amount]);

	useEffect(() => {
		const status = data?.bill?.deposit?.deposit_status;
		if (status === 3) {
			setDepositBtn(true);
			setDepositStr('押金已全部解冻，不可操作');
			return;
		}
		const auth = data?.bill?.deposit?.authorize_status;
		if (auth === 0) {
			// 未授权
			setDepositBtn(true);
			setDepositStr('未授权押金，不可操作');
			return;
		}
		setDepositBtn(false);
		setDepositStr('');
	}, [data?.bill?.deposit?.deposit_status, data?.bill?.deposit?.authorize_status]);

	return (
		<>
			{/* 订单状态=待取车或者已取消不展示 */}
			<Space>
				{data?.order_info?.order_status === 4 || data?.order_info?.order_status === 1 ? null : (
					<Tooltip title={deductStr}>
						<span>
							<SPButton
								type="primary"
								permissionKey="deposit-deduct"
								permission={permission}
								ghost
								onClick={deduction}
								disabled={deductBtn}
							>
								扣款
							</SPButton>
						</span>
					</Tooltip>
				)}
				{data?.order_info?.order_status === 1 ? null : (
					<Tooltip title={refundStr}>
						<span>
							<SPButton
								type="primary"
								permissionKey="order-refund"
								permission={permission}
								ghost
								onClick={refund}
								disabled={refundBtn}
							>
								退款
							</SPButton>
						</span>
					</Tooltip>
				)}
				{data?.order_info?.order_status === 4 || data?.order_info?.order_status === 1 ? null : (
					<Tooltip title={depositStr}>
						<span>
							<SPButton
								type="primary"
								permissionKey="deposit-unfreeze"
								permission={permission}
								ghost
								onClick={unfreezingDeposit}
								disabled={depositBtn}
							>
								解冻押金
							</SPButton>
						</span>
					</Tooltip>
				)}
			</Space>
			<BookingCost data={data?.bill?.order?.main_order || ''} changePriceFormat={changePriceFormat} />
      <DiscountDetails
        data={data?.bill?.order?.promotion || ''}
        enums={enums}
        changePriceFormat={changePriceFormat}
      />
			<DepositDetails data={data?.bill?.deposit || ''} enums={enums} changePriceFormat={changePriceFormat} />
			<RenewalDetails data={data?.bill?.order?.renewal_order || ''} changePriceFormat={changePriceFormat} />
			<DeductionDetails
				allData={data}
				data={data?.bill?.deposit || ''}
				orderCode={data?.order_info?.order_code}
				enums={enums}
				changePriceFormat={changePriceFormat}
				permission={permission}
			/>
			<RefundDetails data={data?.bill?.order?.refund || ''} enums={enums} changePriceFormat={changePriceFormat} />
		</>
	);
};

export default CostInfo;
